import React from "react"
import styled from "styled-components"
import { getStatesByCountryId, getCitiesByStateId } from "../../utils"
import SelectField from "../SelectField"

const StyledCity = styled.div`
  .Menu {
    text-transform: capitalize;
  }
`

class CityField extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      cities: []
    }
  }

  getCities = stateName => {
    const states = getStatesByCountryId()
    const state = states.find(
      state =>
        state.name.toLowerCase() === stateName && state.country_id === "173"
    )
    const cities =
      (state &&
        getCitiesByStateId(state.id) &&
        getCitiesByStateId(state.id).map(city => ({
          value: city.name.toLowerCase(),
          label: city.name.toLowerCase()
        }))) ||
      []
    return cities
  }

  componentDidMount() {
    if (this.props.statename) {
      this.setState(
        state => ({
          ...state,
          cities: this.getCities(this.props.statename)
        }),
        async () => {
          const { name } = this.props.field
          const { setFieldValue } = this.props.form
          const city =
            (this.props.value &&
              this.props.value.value &&
              this.state.cities.find(
                c =>
                  c.value.toLowerCase() === this.props.value.value.toLowerCase()
              )) ||
            ""
          if (this.props.value && this.props.value.value)
            setFieldValue(name, city || "")
          await Promise.resolve()
        }
      )
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.statename !== prevProps.statename) {
      this.setState(
        state => ({
          ...state,
          cities: this.getCities(this.props.statename)
        }),
        async () => {
          const { name } = this.props.field
          const { setFieldValue } = this.props.form
          const city =
            (this.props.value &&
              this.props.value.value &&
              this.state.cities.find(
                c =>
                  c.value.toLowerCase() === this.props.value.value.toLowerCase()
              )) ||
            ""
          setFieldValue(name, city || "")
          await Promise.resolve()
        }
      )
    }
  }

  render() {
    return (
      <StyledCity className="CityField">
        <SelectField
          {...this.props}
          options={
            (this.state.cities.length > 0 && this.state.cities) || [
              {
                value: "none",
                label: ""
              }
            ]
          }
          defaultValue={{ value: "none", label: "" }}
          isDisabled={this.props.disabled || this.state.cities.length <= 0}
        />
      </StyledCity>
    )
  }
}

export default CityField
